import { trackClientEvent } from '@faire/web-api--source/trackClientEvent';
import { ITraceEventMarker } from '@faire/web--source/common/pete/TraceEventTracker';

export const eventKey = 'brands-brand_tile-click';

/**
 * An event for when the user taps on a brand tile.
Parameters: (screen) context, requestId, brandToken
 */
export function trackBrandsBrandTileClick(
  context_string: string,
  requestId_string2: string,
  brandToken: string
): ITraceEventMarker {
  return trackClientEvent({
    eventKey,
    realTimeTracking: false,
    parameters: { context_string, requestId_string2, brandToken },
  });
}
